const a = {
  "cdr-label-standalone": "cdr-label-standalone_15-6-1-beta-4",
  "cdr-label-standalone__label-wrapper": "cdr-label-standalone__label-wrapper_15-6-1-beta-4",
  "cdr-label-standalone__label": "cdr-label-standalone__label_15-6-1-beta-4",
  "cdr-label-standalone__label--sr-only": "cdr-label-standalone__label--sr-only_15-6-1-beta-4",
  "cdr-label-standalone__label--disabled": "cdr-label-standalone__label--disabled_15-6-1-beta-4",
  "cdr-label-standalone__optional": "cdr-label-standalone__optional_15-6-1-beta-4",
  "cdr-label-standalone__helper": "cdr-label-standalone__helper_15-6-1-beta-4",
  "cdr-label-standalone__info": "cdr-label-standalone__info_15-6-1-beta-4",
  "cdr-label-standalone__post-content": "cdr-label-standalone__post-content_15-6-1-beta-4",
  "cdr-label-standalone__info-action": "cdr-label-standalone__info-action_15-6-1-beta-4",
  "cdr-label-standalone__input-wrap": "cdr-label-standalone__input-wrap_15-6-1-beta-4",
  "cdr-label-standalone__input-spacing": "cdr-label-standalone__input-spacing_15-6-1-beta-4"
};
export {
  a as default
};
